
import { createFileRoute } from '@tanstack/react-router'
import { TwoFactorResetRequest } from '@/features/auth/two-factor/request-reset'
import { TwoFactorResetConfirm } from '@/features/auth/two-factor/reset-confirm'
import { z } from 'zod'

const searchSchema = z.object({
    token: z.string().optional(),
})

export const Route = createFileRoute('/(auth)/2fa/reset')({
    component: TwoFactorResetPage,
    validateSearch: searchSchema,
})

function TwoFactorResetPage() {
    const { token } = Route.useSearch()

    if (token) {
        return <TwoFactorResetConfirm />
    }

    return <TwoFactorResetRequest />
}
